[class^='icon-'],
[class*=' icon-'] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'Liebherr-Icons' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

span {
  &.dark {
    @apply text-white;
  }

  &.disabled {
    @apply text-gray-400 pointer-events-none;
    &.dark {
      @apply text-gray-500;
    }
  }
}

/* The following part of the file is auto generated. And will be overwritten periodically. */

.icon-liebherr-components-demand-icon-rgb-64px:before {
	content: '\e900';
}
.icon-liebherr-digital-services-MyMaintenance-remote-support-icon-rgb-64px:before {
	content: '\e901';
}
.icon-liebherr-cage-damage-icon-rgb-64px:before {
	content: '\e902';
}
.icon-liebherr-brandportal-icon-rgb-64px:before {
	content: '\e903';
}
.icon-liebherr-stock-icon-rgb-64px:before {
	content: '\e904';
}
.icon-liebherr-caliper-icon-rgb-64px:before {
	content: '\e905';
}
.icon-liebherr-invisible-icon-rgb-64px:before {
	content: '\e906';
}
.icon-liebherr-smiley-positiv-icon-rgb-64px:before {
	content: '\e907';
}
.icon-liebherr-special-leave-icon-rgb-64px:before {
	content: '\e908';
}
.icon-liebherr-survey-icon-rgb-64px:before {
	content: '\e909';
}
.icon-liebherr-thumbs-down-icon-rgb-64px:before {
	content: '\e90a';
}
.icon-liebherr-thumbs-up-icon-rgb-64px:before {
	content: '\e90b';
}
.icon-liebherr-apple-icon-rgb-64px:before {
	content: '\e90c';
}
.icon-liebherr-application-icon-rgb-64px:before {
	content: '\e90d';
}
.icon-liebherr-application-tips-icon-rgb-64px:before {
	content: '\e90e';
}
.icon-liebherr-area-of-application-icon-rgb-64px:before {
	content: '\e90f';
}
.icon-liebherr-carbon-fibre-reinforced-plastic-icon-rgb-64px:before {
	content: '\e910';
}
.icon-liebherr-certificate-icon-rgb-64px:before {
	content: '\e911';
}
.icon-liebherr-chat-icon-rgb-64px:before {
	content: '\e912';
}
.icon-liebherr-checklist-icon-rgb-64px:before {
	content: '\e913';
}
.icon-liebherr-contacts-icon-rgb-64px:before {
	content: '\e914';
}
.icon-liebherr-data-security-icon-rgb-64px:before {
	content: '\e915';
}
.icon-liebherr-digital-touch-icon-rgb-64px:before {
	content: '\e916';
}
.icon-liebherr-document1-icon-rgb-64px:before {
	content: '\e917';
}
.icon-liebherr-duplicate-icon-rgb-64px:before {
	content: '\e918';
}
.icon-liebherr-eco-icon-rgb-64px:before {
	content: '\e919';
}
.icon-liebherr-employees-icon-rgb-64px:before {
	content: '\e91a';
}
.icon-liebherr-entry-level-icon-rgb-64px:before {
	content: '\e91b';
}
.icon-liebherr-error-rework-icon-rgb-64px:before {
	content: '\e91c';
}
.icon-liebherr-FAQ-icon-rgb-64px:before {
	content: '\e91d';
}
.icon-liebherr-filter-reset-icon-rgb-64px:before {
	content: '\e91e';
}
.icon-liebherr-further-education-funding-icon-rgb-64px:before {
	content: '\e91f';
}
.icon-liebherr-google-icon-rgb-64px:before {
	content: '\e920';
}
.icon-liebherr-images-icon-rgb-64px:before {
	content: '\e921';
}
.icon-liebherr-service-center-icon-rgb-64px:before {
	content: '\e922';
}
.icon-liebherr-inquiry-list-icon-rgb-64px:before {
	content: '\e923';
}
.icon-liebherr-microsoft-icon-rgb-64px:before {
	content: '\e924';
}
.icon-liebherr-offer-icon-rgb-64px:before {
	content: '\e925';
}
.icon-liebherr-onboarding-icon-rgb-64px:before {
	content: '\e926';
}
.icon-liebherr-online-marketing-icon-rgb-64px:before {
	content: '\e927';
}
.icon-liebherr-products-icon-rgb-64px:before {
	content: '\e928';
}
.icon-liebherr-quote-icon-rgb-64px:before {
	content: '\e929';
}
.icon-liebherr-reliable-icon-rgb-64px:before {
	content: '\e92a';
}
.icon-liebherr-scissors-icon-rgb-64px:before {
	content: '\e92b';
}
.icon-liebherr-send-message-icon-rgb-64px:before {
	content: '\e92c';
}
.icon-liebherr-smiley-negativ-icon-rgb-64px:before {
	content: '\e92d';
}
.icon-liebherr-smiley-neutral-icon-rgb-64px:before {
	content: '\e92e';
}
.icon-liebherr-arrow-down-icon-rgb-64px:before {
	content: '\e92f';
}
.icon-liebherr-ballast-1-icon-rgb-64px:before {
	content: '\e930';
}
.icon-liebherr-ballast-2-icon-rgb-64px:before {
	content: '\e931';
}
.icon-liebherr-bin-icon-rgb-64px:before {
	content: '\e932';
}
.icon-liebherr-calender-icon-rgb-64px:before {
	content: '\e933';
}
.icon-liebherr-circle-arrow-right-icon-rgb-64px:before {
	content: '\e934';
}
.icon-liebherr-common-rail-systems-icon-rgb-64px:before {
	content: '\e935';
}
.icon-liebherr-concrete-pumps-icon-rgb-64px:before {
	content: '\e936';
}
.icon-liebherr-concrete-pumps-2-icon-rgb-64px:before {
	content: '\e937';
}
.icon-liebherr-concrete-technology-icon-rgb-64px:before {
	content: '\e938';
}
.icon-liebherr-connected-components-icon-rgb-64px:before {
	content: '\e939';
}
.icon-liebherr-control-technology-icon-rgb-64px:before {
	content: '\e93a';
}
.icon-liebherr-crane-BOS-icon-rgb-64px:before {
	content: '\e93b';
}
.icon-liebherr-crane-CBB-icon-rgb-64px:before {
	content: '\e93c';
}
.icon-liebherr-crane-LHM-icon-rgb-64px:before {
	content: '\e93d';
}
.icon-liebherr-crane-LRS-icon-rgb-64px:before {
	content: '\e93e';
}
.icon-liebherr-crane-MCR-main-icon-rgb-64px:before {
	content: '\e93f';
}
.icon-liebherr-crane-STS-icon-rgb-64px:before {
	content: '\e940';
}
.icon-liebherr-crawler-crane-LWN-icon-rgb-64px:before {
	content: '\e941';
}
.icon-liebherr-crawler-excavator-icon-rgb-64px:before {
	content: '\e942';
}
.icon-liebherr-telescope-loader-icon-rgb-64px:before {
	content: '\e943';
}
.icon-liebherr-deep-foundation-icon-rgb-64px:before {
	content: '\e944';
}
.icon-liebherr-deep-foundation-2-icon-rgb-64px:before {
	content: '\e945';
}
.icon-liebherr-document3-icon-rgb-64px:before {
	content: '\e946';
}
.icon-liebherr-download-icon-rgb-64px:before {
	content: '\e947';
}
.icon-liebherr-duty-cycle-crawler-crane-2-icon-rgb-64px:before {
	content: '\e948';
}
.icon-liebherr-duty-cycle-crawler-crane-icon-rgb-64px:before {
	content: '\e949';
}
.icon-liebherr-electric-machines-icon-rgb-64px:before {
	content: '\e94a';
}
.icon-liebherr-electronics-icon-rgb-64px:before {
	content: '\e94b';
}
.icon-liebherr-extra-jib-icon-rgb-64px:before {
	content: '\e94c';
}
.icon-liebherr-fast-erecting-crane-icon-rgb-64px:before {
	content: '\e94d';
}
.icon-liebherr-filter-adjust-icon-rgb-64px:before {
	content: '\e94e';
}
.icon-liebherr-flat-top-crane-icon-rgb-64px:before {
	content: '\e94f';
}
.icon-liebherr-gateway-icon-rgb-64px:before {
	content: '\e950';
}
.icon-liebherr-gearboxes-icon-rgb-64px:before {
	content: '\e951';
}
.icon-liebherr-generator-icon-rgb-64px:before {
	content: '\e952';
}
.icon-liebherr-high-top-crane-icon-rgb-64px:before {
	content: '\e953';
}
.icon-liebherr-hook-height-icon-rgb-64px:before {
	content: '\e954';
}
.icon-liebherr-hydraulic-cylinders-icon-rgb-64px:before {
	content: '\e955';
}
.icon-liebherr-hydraulic-fast-erecting-crane-icon-rgb-64px:before {
	content: '\e956';
}
.icon-liebherr-hydraulic-pumps-motors-icon-rgb-64px:before {
	content: '\e957';
}
.icon-liebherr-info-circle-icon-rgb-64px:before {
	content: '\e958';
}
.icon-liebherr-info-icon-rgb-64px:before {
	content: '\e959';
}
.icon-liebherr-large-diameter-bearings-icon-rgb-64px:before {
	content: '\e95a';
}
.icon-liebherr-luffing-jib-crane-icon-rgb-64px:before {
	content: '\e95b';
}
.icon-liebherr-material-handling-technology-icon-rgb-64px:before {
	content: '\e95c';
}
.icon-liebherr-measuring-device-icon-rgb-64px:before {
	content: '\e95d';
}
.icon-liebherr-mining-excavator-icon-rgb-64px:before {
	content: '\e95e';
}
.icon-liebherr-mining-icon-rgb-64px:before {
	content: '\e95f';
}
.icon-liebherr-mining-truck-icon-rgb-64px:before {
	content: '\e960';
}
.icon-liebherr-mixing-plant-2-icon-rgb-64px:before {
	content: '\e961';
}
.icon-liebherr-mixing-plant-icon-rgb-64px:before {
	content: '\e962';
}
.icon-liebherr-mobile-construction-crane-icon-rgb-64px:before {
	content: '\e963';
}
.icon-liebherr-mobile-crane-icon-rgb-64px:before {
	content: '\e964';
}
.icon-liebherr-crawler-tractor-icon-rgb-64px:before {
	content: '\e965';
}
.icon-liebherr-plus-icon-rgb-64px:before {
	content: '\e966';
}
.icon-liebherr-printer-icon-rgb-64px:before {
	content: '\e967';
}
.icon-liebherr-quality-icon-rgb-64px:before {
	content: '\e968';
}
.icon-liebherr-reachstacker-icon-rgb-64px:before {
	content: '\e969';
}
.icon-liebherr-rotation-icon-rgb-64px:before {
	content: '\e96a';
}
.icon-liebherr-search-icon-rgb-64px:before {
	content: '\e96b';
}
.icon-liebherr-shopping-cart-icon-rgb-64px:before {
	content: '\e96c';
}
.icon-liebherr-system-drive-technology-icon-rgb-64px:before {
	content: '\e96d';
}
.icon-liebherr-pipe-layer-icon-rgb-64px:before {
	content: '\e96e';
}
.icon-liebherr-telescopic-jib-icon-rgb-64px:before {
	content: '\e96f';
}
.icon-liebherr-user-icon-rgb-64px:before {
	content: '\e970';
}
.icon-liebherr-warning-icon-rgb-64px:before {
	content: '\e971';
}
.icon-liebherr-wheeled-excavator-icon-rgb-64px:before {
	content: '\e972';
}
.icon-liebherr-service-menu-icon-rgb-64px:before {
	content: '\e973';
}
.icon-liebherr-winches-icon-rgb-64px:before {
	content: '\e974';
}
.icon-liebherr-tracking-icon-rgb-64px:before {
	content: '\e975';
}
.icon-liebherr-history-icon-rgb-64px:before {
	content: '\e976';
}
.icon-liebherr-upload-invitation-overview-icon-rgb-64px:before {
	content: '\e977';
}
.icon-liebherr-upload-invitation-icon-rgb-64px:before {
	content: '\e978';
}
.icon-liebherr-my-uploads-icon-rgb-64px:before {
	content: '\e979';
}
.icon-liebherr-upload-icon-rgb-64px:before {
	content: '\e97a';
}
.icon-liebherr-LPS-supplier-portal-icon-rgb-64px:before {
	content: '\e97b';
}
.icon-liebherr-plane-icon-rgb-64px:before {
	content: '\e97c';
}
.icon-liebherr-refrigeration-freezing-icon-rgb-64px:before {
	content: '\e97d';
}
.icon-liebherr-shackle-icon-rgb-64px:before {
	content: '\e97e';
}
.icon-liebherr-service-icon-rgb-64px:before {
	content: '\e97f';
}
.icon-liebherr-back-arrow-circle-icon-rgb-64px:before {
	content: '\e980';
}
.icon-liebherr-checkmark-icon-rgb-64px:before {
	content: '\e981';
}
.icon-liebherr-edit-icon-rgb-64px:before {
	content: '\e982';
}
.icon-liebherr-aerospace-transportation-system-2-icon-rgb-64px:before {
	content: '\e983';
}
.icon-liebherr-x-icon-rgb-64px:before {
	content: '\e984';
}
.icon-liebherr-service-partner-icon-rgb-64px:before {
	content: '\e985';
}
.icon-liebherr-unused-employee-potential-icon-rgb-64px:before {
	content: '\e986';
}
.icon-liebherr-wheel-loader-big-icon-rgb-64px:before {
	content: '\e987';
}
.icon-liebherr-wheel-loader-small-icon-rgb-64px:before {
	content: '\e988';
}
.icon-liebherr-crawler-loader-icon-rgb-64px:before {
	content: '\e989';
}
.icon-liebherr-envelope-icon-rgb-64px:before {
	content: '\e98a';
}
.icon-liebherr-fax-icon-rgb-64px:before {
	content: '\e98b';
}
.icon-liebherr-health-activities-icon-rgb-64px:before {
	content: '\e98c';
}
.icon-liebherr-plane-take-off-icon-rgb-64px:before {
	content: '\e98d';
}
.icon-liebherr-predictive-maintenance-icon-rgb-64px:before {
	content: '\e98e';
}
.icon-liebherr-hotels-icon-rgb-64px:before {
	content: '\e98f';
}
.icon-liebherr-order-details-icon-rgb-64px:before {
	content: '\e990';
}
.icon-liebherr-product-catalog-icon-rgb-64px:before {
	content: '\e991';
}
.icon-liebherr-product-documents-icon-rgb-64px:before {
	content: '\e992';
}
.icon-liebherr-instagram-icon-rgb-64px:before {
	content: '\e993';
}
.icon-liebherr-kununu-icon-rgb-64px:before {
	content: '\e994';
}
.icon-liebherr-linkedin-icon-rgb-64px:before {
	content: '\e995';
}
.icon-liebherr-twitter-icon-rgb-64px:before {
	content: '\e996';
}
.icon-liebherr-xing-icon-rgb-64px:before {
	content: '\e997';
}
.icon-liebherr-facebook-icon-rgb-64px:before {
	content: '\e998';
}
.icon-liebherr-virus-pathogen-icon-rgb-64px:before {
	content: '\e999';
}
.icon-liebherr-visible-icon-rgb-64px:before {
	content: '\e99a';
}
.icon-liebherr-shaking-hands-prohibited-icon-rgb-64px:before {
	content: '\e99b';
}
.icon-liebherr-spare-parts-catalog-icon-rgb-64px:before {
	content: '\e99c';
}
.icon-liebherr-volume-icon-rgb-64px:before {
	content: '\e99d';
}
.icon-liebherr-volume-off-icon-rgb-64px:before {
	content: '\e99e';
}
.icon-liebherr-workwear-icon-rgb-64px:before {
	content: '\e99f';
}
.icon-liebherr-aerospace-transportation-system-1-icon-rgb-64px:before {
	content: '\e9a0';
}
.icon-liebherr-components-icon-rgb-64px:before {
	content: '\e9a1';
}
.icon-liebherr-gear-cutting-technology-automation-icon-rgb-64px:before {
	content: '\e9a2';
}
.icon-liebherr-star-black-icon-rgb-64px:before {
	content: '\e9a3';
}
.icon-liebherr-star-icon-rgb-64px:before {
	content: '\e9a4';
}
.icon-liebherr-youtube-icon-rgb-64px:before {
	content: '\e9a5';
}
.icon-liebherr-save-icon-rgb-64px:before {
	content: '\e9a6';
}
.icon-liebherr-team-icon-rgb-64px:before {
	content: '\e9a7';
}
.icon-liebherr-webshop-icon-rgb-64px:before {
	content: '\e9a8';
}
.icon-liebherr-active-sourcing-icon-rgb-64px:before {
	content: '\e9a9';
}
.icon-liebherr-billboard-icon-rgb-64px:before {
	content: '\e9aa';
}
.icon-liebherr-booth-icon-rgb-64px:before {
	content: '\e9ab';
}
.icon-liebherr-brain-icon-rgb-64px:before {
	content: '\e9ac';
}
.icon-liebherr-brand-ambassador-icon-rgb-64px:before {
	content: '\e9ad';
}
.icon-liebherr-care-icon-rgb-64px:before {
	content: '\e9ae';
}
.icon-liebherr-chat-cell-phone-icon-rgb-64px:before {
	content: '\e9af';
}
.icon-liebherr-classes-icon-rgb-64px:before {
	content: '\e9b0';
}
.icon-liebherr-cloud-icon-rgb-64px:before {
	content: '\e9b1';
}
.icon-liebherr-coolant-icon-rgb-64px:before {
	content: '\e9b2';
}
.icon-liebherr-drone-icon-rgb-64px:before {
	content: '\e9b3';
}
.icon-liebherr-e-learning-icon-rgb-64px:before {
	content: '\e9b4';
}
.icon-liebherr-employee-events-icon-rgb-64px:before {
	content: '\e9b5';
}
.icon-liebherr-employer-funded-pension-icon-rgb-64px:before {
	content: '\e9b6';
}
.icon-liebherr-favourites-icon-rgb-64px:before {
	content: '\e9b7';
}
.icon-liebherr-film-icon-rgb-64px:before {
	content: '\e9b8';
}
.icon-liebherr-flexible-working-hours-icon-rgb-64px:before {
	content: '\e9b9';
}
.icon-liebherr-font-arrow-icon-rgb-64px:before {
	content: '\e9ba';
}
.icon-liebherr-gifts-for-employees-icon-rgb-64px:before {
	content: '\e9bb';
}
.icon-liebherr-inquiry-icon-rgb-64px:before {
	content: '\e9bc';
}
.icon-liebherr-target-group-icon-rgb-64px:before {
	content: '\e9bd';
}
.icon-liebherr-job-interview-icon-rgb-64px:before {
	content: '\e9be';
}
.icon-liebherr-leisure-offers-icon-rgb-64px:before {
	content: '\e9bf';
}
.icon-liebherr-licensing-software-icon-rgb-64px:before {
	content: '\e9c0';
}
.icon-liebherr-medal-icon-rgb-64px:before {
	content: '\e9c1';
}
.icon-liebherr-menu-icon-rgb-64px:before {
	content: '\e9c2';
}
.icon-liebherr-my-notifier-icon-rgb-64px:before {
	content: '\e9c3';
}
.icon-liebherr-pause-icon-rgb-64px:before {
	content: '\e9c4';
}
.icon-liebherr-personnel-development-icon-rgb-64px:before {
	content: '\e9c5';
}
.icon-liebherr-pharma-icon-rgb-64px:before {
	content: '\e9c6';
}
.icon-liebherr-phone-charger-icon-rgb-64px:before {
	content: '\e9c7';
}
.icon-liebherr-play-icon-rgb-64px:before {
	content: '\e9c8';
}
.icon-liebherr-poster-icon-rgb-64px:before {
	content: '\e9c9';
}
.icon-liebherr-radio-icon-rgb-64px:before {
	content: '\e9ca';
}
.icon-liebherr-resource-friendly-icon-rgb-64px:before {
	content: '\e9cb';
}
.icon-liebherr-settings-icon-rgb-64px:before {
	content: '\e9cc';
}
.icon-liebherr-stop-icon-rgb-64px:before {
	content: '\e9cd';
}
.icon-liebherr-projects-icon-rgb-64px:before {
	content: '\e9ce';
}
.icon-liebherr-phone-icon-rgb-64px:before {
	content: '\e9cf';
}
.icon-liebherr-sorting-grab-icon-rgb-64px:before {
	content: '\e9d0';
}
.icon-liebherr-speed-icon-rgb-64px:before {
	content: '\e9d1';
}
.icon-liebherr-stick-extension-icon-rgb-64px:before {
	content: '\e9d2';
}
.icon-liebherr-sustainability-icon-rgb-64px:before {
	content: '\e9d3';
}
.icon-liebherr-tiltrotator-icon-rgb-64px:before {
	content: '\e9d4';
}
.icon-liebherr-transport-logistics-icon-rgb-64px:before {
	content: '\e9d5';
}
.icon-liebherr-triangle-with-exclamation-mark-icon-rgb-64px:before {
	content: '\e9d6';
}
.icon-liebherr-universal-bucket-wheel-loader-icon-rgb-64px:before {
	content: '\e9d7';
}
.icon-liebherr-visits-to-doctor-during-working-hours-icon-rgb-64px:before {
	content: '\e9d8';
}
.icon-liebherr-wash-your-hands-icon-rgb-64px:before {
	content: '\e9d9';
}
.icon-liebherr-WDS-eldercare-icon-rgb-64px:before {
	content: '\e9da';
}
.icon-liebherr-weight-icon-rgb-64px:before {
	content: '\e9db';
}
.icon-liebherr-wind-energy-icon-rgb-64px:before {
	content: '\e9dc';
}
.icon-liebherr-wood-grab-icon-rgb-64px:before {
	content: '\e9dd';
}
.icon-liebherr-2-1-bucket-icon-rgb-64px:before {
	content: '\e9de';
}
.icon-liebherr-4in1-bucket-icon-rgb-64px:before {
	content: '\e9df';
}
.icon-liebherr-adapter-plate-icon-rgb-64px:before {
	content: '\e9e0';
}
.icon-liebherr-AGG-Information-icon-rgb-64px:before {
	content: '\e9e1';
}
.icon-liebherr-angle-90-degrees-icon-rgb-64px:before {
	content: '\e9e2';
}
.icon-liebherr-app-launcher-icon-rgb-64px:before {
	content: '\e9e3';
}
.icon-liebherr-battery-icon-rgb-64px:before {
	content: '\e9e4';
}
.icon-liebherr-BGM-Liebherr-icon-rgb-64px:before {
	content: '\e9e5';
}
.icon-liebherr-boom-configurations-icon-rgb-64px:before {
	content: '\e9e6';
}
.icon-liebherr-bluetooth-icon-rgb-64px:before {
	content: '\e9e7';
}
.icon-liebherr-lin-icon-rgb-64px:before {
	content: '\e9e8';
}
.icon-liebherr-my-jobsite-icon-rgb-64px:before {
	content: '\e9e9';
}
.icon-liebherr-cloud-1-icon-rgb-64px:before {
	content: '\e9ea';
}
.icon-liebherr-lh-signal-info-icon-rgb-64px:before {
	content: '\e9eb';
}
.icon-liebherr-lh-web-platform-icon-rgb-64px:before {
	content: '\e9ec';
}
.icon-liebherr-sport-1-icon-rgb-64px:before {
	content: '\e9ed';
}
.icon-liebherr-breakdown-icon-rgb-64px:before {
	content: '\e9ee';
}
.icon-liebherr-break-regulations-normal-workers-icon-rgb-64px:before {
	content: '\e9ef';
}
.icon-liebherr-break-regulations-shift-workers-icon-rgb-64px:before {
	content: '\e9f0';
}
.icon-liebherr-bucket-icon-rgb-64px:before {
	content: '\e9f1';
}
.icon-liebherr-bucket-telescopic-loader-icon-rgb-64px:before {
	content: '\e9f2';
}
.icon-liebherr-care-concept-icon-rgb-64px:before {
	content: '\e9f3';
}
.icon-liebherr-checklist-2-icon-rgb-64px:before {
	content: '\e9f4';
}
.icon-liebherr-children-sick-pay-icon-rgb-64px:before {
	content: '\e9f5';
}
.icon-liebherr-civil-construction-icon-rgb-64px:before {
	content: '\e9f6';
}
.icon-liebherr-clamshell-grab-icon-rgb-64px:before {
	content: '\e9f7';
}
.icon-liebherr-commercial-education-icon-rgb-64px:before {
	content: '\e9f8';
}
.icon-liebherr-control-assistance-systems-icon-rgb-64px:before {
	content: '\e9f9';
}
.icon-liebherr-conveyor-belt-icon-rgb-64px:before {
	content: '\e9fa';
}
.icon-liebherr-cooling-icon-rgb-64px:before {
	content: '\e9fb';
}
.icon-liebherr-damage-icon-rgb-64px:before {
	content: '\e9fc';
}
.icon-liebherr-data-exchange-icon-rgb-64px:before {
	content: '\e9fd';
}
.icon-liebherr-deep-foundation-1-icon-rgb-64px:before {
	content: '\e9fe';
}
.icon-liebherr-derrick-counterweight-icon-rgb-64px:before {
	content: '\e9ff';
}
.icon-liebherr-microphone-icon-rgb-64px:before {
	content: '\ea00';
}
.icon-liebherr-sport-2-icon-rgb-64px:before {
	content: '\ea01';
}
.icon-liebherr-crane-finder-icon-rgb-64px:before {
	content: '\ea02';
}
.icon-liebherr-engine-production-icon-rgb-64px:before {
	content: '\ea03';
}
.icon-liebherr-lidia-icon-rgb-64px:before {
	content: '\ea04';
}
.icon-liebherr-enginge-diagnostic-icon-rgb-64px:before {
	content: '\ea05';
}
.icon-liebherr-sport-6-icon-rgb-64px:before {
	content: '\ea06';
}
.icon-liebherr-sport-3-icon-rgb-64px:before {
	content: '\ea07';
}
.icon-liebherr-sport-9-icon-rgb-64px:before {
	content: '\ea08';
}
.icon-liebherr-sport-8-icon-rgb-64px:before {
	content: '\ea09';
}
.icon-liebherr-sport-5-icon-rgb-64px:before {
	content: '\ea0a';
}
.icon-liebherr-sport-4-icon-rgb-64px:before {
	content: '\ea0b';
}
.icon-liebherr-sport-7-icon-rgb-64px:before {
	content: '\ea0c';
}
.icon-liebherr-robotics-icon-rgb-64px:before {
	content: '\ea0d';
}
.icon-liebherr-digital-signage-icon-rgb-64px:before {
	content: '\ea0e';
}
.icon-liebherr-user-permission-icon-rgb-64px:before {
	content: '\ea0f';
}
.icon-liebherr-tractor-icon-rgb-64px:before {
	content: '\ea10';
}
.icon-liebherr-smart-city-icon-rgb-64px:before {
	content: '\ea11';
}
.icon-liebherr-double-gearwheel-icon-rgb-64px:before {
	content: '\ea12';
}
.icon-liebherr-dozer-blade-icon-rgb-64px:before {
	content: '\ea13';
}
.icon-liebherr-dump-height-at-max-lift-height-icon-rgb-64px:before {
	content: '\ea14';
}
.icon-liebherr-environmental-damage-icon-rgb-64px:before {
	content: '\ea15';
}
.icon-liebherr-family-business-icon-rgb-64px:before {
	content: '\ea16';
}
.icon-liebherr-file-icon-rgb-64px:before {
	content: '\ea17';
}
.icon-liebherr-filter-module-for-diesel-particles-icon-rgb-64px:before {
	content: '\ea18';
}
.icon-liebherr-folding-shovel-icon-rgb-64px:before {
	content: '\ea19';
}
.icon-liebherr-forklift-icon-rgb-64px:before {
	content: '\ea1a';
}
.icon-liebherr-fuel-savings-calculator-icon-rgb-64px:before {
	content: '\ea1b';
}
.icon-liebherr-grab-bucket-telescopic-loader-icon-rgb-64px:before {
	content: '\ea1c';
}
.icon-liebherr-grab-telescopic-loader-icon-rgb-64px:before {
	content: '\ea1d';
}
.icon-liebherr-H2-icon-rgb-64px:before {
	content: '\ea1e';
}
.icon-liebherr-hand-icon-rgb-64px:before {
	content: '\ea1f';
}
.icon-liebherr-Hans-Liebherr-Hilfe-eV-icon-rgb-64px:before {
	content: '\ea20';
}
.icon-liebherr-high-silo-icon-rgb-64px:before {
	content: '\ea21';
}
.icon-liebherr-house-search-icon-rgb-64px:before {
	content: '\ea22';
}
.icon-liebherr-hydraulic-manipulators-icon-rgb-64px:before {
	content: '\ea23';
}
.icon-liebherr-hydraulic-power-unit-icon-rgb-64px:before {
	content: '\ea24';
}
.icon-liebherr-light-material-bucket-wheel-loader-icon-rgb-64px:before {
	content: '\ea25';
}
.icon-liebherr-LiTiU-icon-rgb-64px:before {
	content: '\ea26';
}
.icon-liebherr-load-hook-icon-rgb-64px:before {
	content: '\ea27';
}
.icon-liebherr-load-hook-telescopic-loader-icon-rgb-64px:before {
	content: '\ea28';
}
.icon-liebherr-load-hook-wheel-loader-icon-rgb-64px:before {
	content: '\ea29';
}
.icon-liebherr-log-grapple-wheel-loader-icon-rgb-64px:before {
	content: '\ea2a';
}
.icon-liebherr-magnet-icon-rgb-64px:before {
	content: '\ea2b';
}
.icon-liebherr-maternity-leave-process-icon-rgb-64px:before {
	content: '\ea2c';
}
.icon-liebherr-maternity-protection-icon-rgb-64px:before {
	content: '\ea2d';
}
.icon-liebherr-maximum-lifting-height-icon-rgb-64px:before {
	content: '\ea2e';
}
.icon-liebherr-maximum-load-capacity-icon-rgb-64px:before {
	content: '\ea2f';
}
.icon-liebherr-maximum-reach-icon-rgb-64px:before {
	content: '\ea30';
}
.icon-liebherr-multi-tine-grab-icon-rgb-64px:before {
	content: '\ea31';
}
.icon-liebherr-news_2-icon-rgb-64px:before {
	content: '\ea32';
}
.icon-liebherr-pallet-fork-icon-rgb-64px:before {
	content: '\ea33';
}
.icon-liebherr-pay-slip-specification-icon-rgb-64px:before {
	content: '\ea34';
}
.icon-liebherr-petrochemical-icon-rgb-64px:before {
	content: '\ea35';
}
.icon-liebherr-piston-accumulator-icon-rgb-64px:before {
	content: '\ea36';
}
.icon-liebherr-port-floating-icon-rgb-64px:before {
	content: '\ea37';
}
.icon-liebherr-power-plant-icon-rgb-64px:before {
	content: '\ea38';
}
.icon-liebherr-quick-coupler-icon-rgb-64px:before {
	content: '\ea39';
}
.icon-liebherr-quick-coupler-MH-icon-rgb-64px:before {
	content: '\ea3a';
}
.icon-liebherr-quick-coupler-wheel-loader-icon-rgb-64px:before {
	content: '\ea3b';
}
.icon-liebherr-recycle-icon-rgb-64px:before {
	content: '\ea3c';
}
.icon-liebherr-recycle-with-text-icon-rgb-64px:before {
	content: '\ea3d';
}
.icon-liebherr-reduce-icon-rgb-64px:before {
	content: '\ea3e';
}
.icon-liebherr-reduce-with-text-icon-rgb-64px:before {
	content: '\ea3f';
}
.icon-liebherr-reuse-icon-rgb-64px:before {
	content: '\ea40';
}
.icon-liebherr-reuse-with-text-icon-rgb-64px:before {
	content: '\ea41';
}
.icon-liebherr-rock-shovel-icon-rgb-64px:before {
	content: '\ea42';
}
.icon-liebherr-bucket-volume-icon-rgb-64px:before {
	content: '\ea43';
}
.icon-liebherr-arrow-up-icon-rgb-64px:before {
	content: '\ea44';
}
.icon-liebherr-arrow-down-1-icon-rgb-64px:before {
	content: '\ea45';
}
.icon-liebherr-add-on-parts-icon-rgb-64px:before {
	content: '\ea46';
}
.icon-liebherr-to-the-top-icon-rgb-64px:before {
	content: '\ea47';
}
.icon-liebherr-table-icon-rgb-64px:before {
	content: '\ea48';
}
.icon-liebherr-slider-right-icon-rgb-64px:before {
	content: '\ea49';
}
.icon-liebherr-brushes-icon-rgb-64px:before {
	content: '\ea4a';
}
.icon-liebherr-plug-icon-rgb-64px:before {
	content: '\ea4b';
}
.icon-liebherr-organization-chart-icon-rgb-64px:before {
	content: '\ea4c';
}
.icon-liebherr-harvester-icon-rgb-64px:before {
	content: '\ea4d';
}
.icon-liebherr-connected-fab-icon-rgb-64px:before {
	content: '\ea4e';
}
.icon-liebherr-smart-farming-icon-rgb-64px:before {
	content: '\ea4f';
}
.icon-liebherr-everyday-mask-icon-rgb-64px:before {
	content: '\ea50';
}
.icon-liebherr-MDC3-icon-rgb-64px:before {
	content: '\ea51';
}
.icon-liebherr-menu-small-icon-rgb-64px:before {
	content: '\ea52';
}
.icon-liebherr-user-logged-icon-rgb-64px:before {
	content: '\ea53';
}
.icon-liebherr-user-log-in-icon-rgb-64px:before {
	content: '\ea54';
}
.icon-liebherr-BCM-App-icon-rgb-64px:before {
	content: '\ea55';
}
.icon-liebherr-calibration-icon-rgb-64px:before {
	content: '\ea56';
}
.icon-liebherr-display-icon-rgb-64px:before {
	content: '\ea57';
}
.icon-liebherr-Ecu-icon-rgb-64px:before {
	content: '\ea58';
}
.icon-liebherr-HDR-icon-rgb-64px:before {
	content: '\ea59';
}
.icon-liebherr-light-conditions-icon-rgb-64px:before {
	content: '\ea5a';
}
.icon-liebherr-online-truck-mixer-configurators-icon-rgb-64px:before {
	content: '\ea5b';
}
.icon-liebherr-linfos-20-icon-rgb-64px:before {
	content: '\ea5c';
}
.icon-liebherr-concrete-telematics-icon-rgb-64px:before {
	content: '\ea5d';
}
.icon-liebherr-excellence-components-icon-rgb-64px:before {
	content: '\ea5e';
}
.icon-liebherr-crane-load-capacity-icon-rgb-64px:before {
	content: '\ea5f';
}
.icon-liebherr-torque-icon-rgb-64px:before {
	content: '\ea60';
}
.icon-liebherr-grab-volume-yd-icon-rgb-64px:before {
	content: '\ea61';
}
.icon-liebherr-grab-volume-m-icon-rgb-64px:before {
	content: '\ea62';
}
.icon-liebherr-grab-volume-m-yd-icon-rgb-64px:before {
	content: '\ea63';
}
.icon-liebherr-grab-closing-force-icon-rgb-64px:before {
	content: '\ea64';
}
.icon-liebherr-lighthouse-icon-rgb-64px:before {
	content: '\ea65';
}
.icon-liebherr-rocket-icon-rgb-64px:before {
	content: '\ea66';
}
.icon-liebherr-electronic-invoice-icon-rgb-64px:before {
	content: '\ea67';
}
.icon-liebherr-LICCON-Einsatzplaner-icon-rgb-64px:before {
	content: '\ea68';
}
.icon-liebherr-telemetry-icon-rgb-64px:before {
	content: '\ea69';
}
.icon-liebherr-alternative-fuels-icon-rgb-64px:before {
	content: '\ea6a';
}
.icon-liebherr-cleaning-freedom-icon-rgb-64px:before {
	content: '\ea6b';
}
.icon-liebherr-adjustable-feet-icon-rgb-64px:before {
	content: '\ea6c';
}
.icon-liebherr-smart-camera-icon-rgb-64px:before {
	content: '\ea6d';
}
.icon-liebherr-snapshot-icon-rgb-64px:before {
	content: '\ea6e';
}
.icon-liebherr-faster-icon-rgb-64px:before {
	content: '\ea6f';
}
.icon-liebherr-corrosion-damages-icon-rgb-64px:before {
	content: '\ea70';
}
.icon-liebherr-export-icon-rgb-64px:before {
	content: '\ea71';
}
.icon-liebherr-fire-icon-rgb-64px:before {
	content: '\ea72';
}
.icon-liebherr-frequency-inverter-cabinet-icon-rgb-64px:before {
	content: '\ea73';
}
.icon-liebherr-further-options-2-icon-rgb-64px:before {
	content: '\ea74';
}
.icon-liebherr-gear-damage-icon-rgb-64px:before {
	content: '\ea75';
}
.icon-liebherr-individualization-icon-rgb-64px:before {
	content: '\ea76';
}
.icon-liebherr-innovative-sealings-icon-rgb-64px:before {
	content: '\ea77';
}
.icon-liebherr-over-production-icon-rgb-64px:before {
	content: '\ea78';
}
.icon-liebherr-oversized-processes-icon-rgb-64px:before {
	content: '\ea79';
}
.icon-liebherr-special-fats-icon-rgb-64px:before {
	content: '\ea7a';
}
.icon-liebherr-aministrator-icon-rgb-64px:before {
	content: '\ea7b';
}
.icon-liebherr-crane-planner-icon-rgb-64px:before {
	content: '\ea7c';
}
.icon-liebherr-surface-treatment-icon-rgb-64px:before {
	content: '\ea7d';
}
.icon-liebherr-slider-left-icon-rgb-64px:before {
	content: '\ea7e';
}
.icon-liebherr-reparatur-icon-rgb-64px:before {
	content: '\ea7f';
}
.icon-liebherr-recycling-plants-icon-rgb-64px:before {
	content: '\ea80';
}
.icon-liebherr-qualifications-icon-rgb-64px:before {
	content: '\ea81';
}
.icon-liebherr-move-icon-rgb-64px:before {
	content: '\ea82';
}
.icon-liebherr-mixing-systems-icon-rgb-64px:before {
	content: '\ea83';
}
.icon-liebherr-minus-icon-rgb-64px:before {
	content: '\ea84';
}
.icon-liebherr-language-of-job-icon-rgb-64px:before {
	content: '\ea85';
}
.icon-liebherr-joystick-icon-rgb-64px:before {
	content: '\ea86';
}
.icon-liebherr-job-title-icon-rgb-64px:before {
	content: '\ea87';
}
.icon-liebherr-hook-position-icon-rgb-64px:before {
	content: '\ea88';
}
.icon-liebherr-gripper-icon-rgb-64px:before {
	content: '\ea89';
}
.icon-liebherr-give-aways-icon-rgb-64px:before {
	content: '\ea8a';
}
.icon-liebherr-general-overhaul-icon-rgb-64px:before {
	content: '\ea8b';
}
.icon-liebherr-further-options-1-icon-rgb-64px:before {
	content: '\ea8c';
}
.icon-liebherr-exchange-components-icon-rgb-64px:before {
	content: '\ea8d';
}
.icon-liebherr-evaluation-old-part-icon-rgb-64px:before {
	content: '\ea8e';
}
.icon-liebherr-erc-system-icon-rgb-64px:before {
	content: '\ea8f';
}
.icon-liebherr-eiffel-tower-icon-rgb-64px:before {
	content: '\ea90';
}
.icon-liebherr-dump-truck-icon-rgb-64px:before {
	content: '\ea91';
}
.icon-liebherr-desinfection-icon-rgb-64px:before {
	content: '\ea92';
}
.icon-liebherr-crane-climbing-icon-rgb-64px:before {
	content: '\ea93';
}
.icon-liebherr-font-arrow-left-icon-rgb-64px:before {
	content: '\ea94';
}
.icon-liebherr-PHS-Allround-icon-rgb-64px:before {
	content: '\ea95';
}
.icon-liebherr-link-2-icon-rgb-64px:before {
	content: '\ea96';
}
.icon-liebherr-ersthelfer-icon-rgb-64px:before {
	content: '\ea97';
}
.icon-liebherr-price-check-icon-rgb-64px:before {
	content: '\ea98';
}
.icon-liebherr-discount-icon-rgb-64px:before {
	content: '\ea99';
}
.icon-liebherr-ponton-bagger-icon-rgb-64px:before {
	content: '\ea9a';
}
.icon-liebherr-invoice-icon-rgb-64px:before {
	content: '\ea9b';
}
.icon-liebherr-credit-card-icon-rgb-64px:before {
	content: '\ea9c';
}
.icon-liebherr-prepayment-icon-rgb-64px:before {
	content: '\ea9d';
}
.icon-liebherr-visa-icon-rgb-64px:before {
	content: '\ea9e';
}
.icon-liebherr-paypal-icon-rgb-64px:before {
	content: '\ea9f';
}
.icon-liebherr-sofort-icon-rgb-64px:before {
	content: '\eaa0';
}
.icon-liebherr-mastercard-icon-rgb-64px:before {
	content: '\eaa1';
}
.icon-liebherr-heart-black-icon-rgb-64px:before {
	content: '\eaa2';
}
.icon-liebherr-forbidden-icon-rgb-64px:before {
	content: '\eaa3';
}
.icon-liebherr-bottle-icon-rgb-64px:before {
	content: '\eaa4';
}
.icon-liebherr-product-configurator-icon-rgb-64px:before {
	content: '\eaa5';
}
.icon-liebherr-keep-distance-icon-rgb-64px:before {
	content: '\eaa6';
}
.icon-liebherr-music-icon-rgb-64px:before {
	content: '\eaa7';
}
.icon-liebherr-sun-icon-rgb-64px:before {
	content: '\eaa8';
}
.icon-liebherr-waves-icon-rgb-64px:before {
	content: '\eaa9';
}
.icon-liebherr-wind-energy-plant-icon-rgb-64px:before {
	content: '\eaaa';
}
.icon-liebherr-5G-antenne-icon-rgb-64px:before {
	content: '\eaab';
}
.icon-liebherr-additional-payment-icon-rgb-64px:before {
	content: '\eaac';
}
.icon-liebherr-apple-core-icon-rgb-64px:before {
	content: '\eaad';
}
.icon-liebherr-attractive-salary-icon-rgb-64px:before {
	content: '\eaae';
}
.icon-liebherr-axle-oils-icon-rgb-64px:before {
	content: '\eaaf';
}
.icon-liebherr-business-cell-phones-icon-rgb-64px:before {
	content: '\eab0';
}
.icon-liebherr-care-packs-icon-rgb-64px:before {
	content: '\eab1';
}
.icon-liebherr-childcare-icon-rgb-64px:before {
	content: '\eab2';
}
.icon-liebherr-circle-arrow-clockwise-icon-rgb-64px:before {
	content: '\eab3';
}
.icon-liebherr-cocktail-glas-1-icon-rgb-64px:before {
	content: '\eab4';
}
.icon-liebherr-cocktail-glass-2-icon-rgb-64px:before {
	content: '\eab5';
}
.icon-liebherr-cocktail-glass-3-icon-rgb-64px:before {
	content: '\eab6';
}
.icon-liebherr-cocktail-glass-4-icon-rgb-64px:before {
	content: '\eab7';
}
.icon-liebherr-company-apartments-icon-rgb-64px:before {
	content: '\eab8';
}
.icon-liebherr-conical-flask-icon-rgb-64px:before {
	content: '\eab9';
}
.icon-liebherr-container-vessel-icon-rgb-64px:before {
	content: '\eaba';
}
.icon-liebherr-electrolyzer-icon-rgb-64px:before {
	content: '\eabb';
}
.icon-liebherr-empowerment-icon-rgb-64px:before {
	content: '\eabc';
}
.icon-liebherr-engine-oils-icon-rgb-64px:before {
	content: '\eabd';
}
.icon-liebherr-ergonomic-equipment-icon-rgb-64px:before {
	content: '\eabe';
}
.icon-liebherr-family-and-work-icon-rgb-64px:before {
	content: '\eabf';
}
.icon-liebherr-fats-icon-rgb-64px:before {
	content: '\eac0';
}
.icon-liebherr-gear-oils-icon-rgb-64px:before {
	content: '\eac1';
}
.icon-liebherr-goods-incoming-icon-rgb-64px:before {
	content: '\eac2';
}
.icon-liebherr-goods-outgoing-icon-rgb-64px:before {
	content: '\eac3';
}
.icon-liebherr-home-office-icon-rgb-64px:before {
	content: '\eac4';
}
.icon-liebherr-hydraulic-oils-icon-rgb-64px:before {
	content: '\eac5';
}
.icon-liebherr-identity-secured-icon-rgb-64px:before {
	content: '\eac6';
}
.icon-liebherr-initiative-application-icon-rgb-64px:before {
	content: '\eac7';
}
.icon-liebherr-innovations-icon-rgb-64px:before {
	content: '\eac8';
}
.icon-liebherr-IP-icon-rgb-64px:before {
	content: '\eac9';
}
.icon-liebherr-jobcenter-icon-rgb-64px:before {
	content: '\eaca';
}
.icon-liebherr-lubricants-icon-rgb-64px:before {
	content: '\eacb';
}
.icon-liebherr-LVT-icon-rgb-64px:before {
	content: '\eacc';
}
.icon-liebherr-management-cockpit-icon-rgb-64px:before {
	content: '\eacd';
}
.icon-liebherr-modern-workplace-production-icon-rgb-64px:before {
	content: '\eace';
}
.icon-liebherr-money-liquidity-icon-rgb-64px:before {
	content: '\eacf';
}
.icon-liebherr-money-secured-icon-rgb-64px:before {
	content: '\ead0';
}
.icon-liebherr-monorail-icon-rgb-64px:before {
	content: '\ead1';
}
.icon-liebherr-news-icon-rgb-64px:before {
	content: '\ead2';
}
.icon-liebherr-NFC-RFID-icon-rgb-64px:before {
	content: '\ead3';
}
.icon-liebherr-package-icon-rgb-64px:before {
	content: '\ead4';
}
.icon-liebherr-pc-icon-rgb-64px:before {
	content: '\ead5';
}
.icon-liebherr-productivity-icon-rgb-64px:before {
	content: '\ead6';
}
.icon-liebherr-profitability-icon-rgb-64px:before {
	content: '\ead7';
}
.icon-liebherr-reman-programm-icon-rgb-64px:before {
	content: '\ead8';
}
.icon-liebherr-rss-feed-frame-icon-rgb-64px:before {
	content: '\ead9';
}
.icon-liebherr-rss-feed-icon-rgb-64px:before {
	content: '\eada';
}
.icon-liebherr-satellite-icon-rgb-64px:before {
	content: '\eadb';
}
.icon-liebherr-screw-paste-icon-rgb-64px:before {
	content: '\eadc';
}
.icon-liebherr-solar-panel-icon-rgb-64px:before {
	content: '\eadd';
}
.icon-liebherr-spray-hot-surfaces-icon-rgb-64px:before {
	content: '\eade';
}
.icon-liebherr-spray-hydraulic-cylinder-icon-rgb-64px:before {
	content: '\eadf';
}
.icon-liebherr-spray-icon-rgb-64px:before {
	content: '\eae0';
}
.icon-liebherr-star-plus-icon-rgb-64px:before {
	content: '\eae1';
}
.icon-liebherr-dinner-icon-rgb-64px:before {
	content: '\eae2';
}
.icon-liebherr-document2-icon-rgb-64px:before {
	content: '\eae3';
}
.icon-liebherr-elevator-icon-rgb-64px:before {
	content: '\eae4';
}
.icon-liebherr-entrance-icon-rgb-64px:before {
	content: '\eae5';
}
.icon-liebherr-heart-icon-rgb-64px:before {
	content: '\eae6';
}
.icon-liebherr-helicopter-icon-rgb-64px:before {
	content: '\eae7';
}
.icon-liebherr-home-icon-rgb-64px:before {
	content: '\eae8';
}
.icon-liebherr-info-person-icon-rgb-64px:before {
	content: '\eae9';
}
.icon-liebherr-lock-closed-icon-rgb-64px:before {
	content: '\eaea';
}
.icon-liebherr-lock-open-icon-rgb-64px:before {
	content: '\eaeb';
}
.icon-liebherr-man-icon-rgb-64px:before {
	content: '\eaec';
}
.icon-liebherr-map-icon-rgb-64px:before {
	content: '\eaed';
}
.icon-liebherr-map-location-icon-rgb-64px:before {
	content: '\eaee';
}
.icon-liebherr-parking-icon-rgb-64px:before {
	content: '\eaef';
}
.icon-liebherr-question-mark-icon-rgb-64px:before {
	content: '\eaf0';
}
.icon-liebherr-rack-icon-rgb-64px:before {
	content: '\eaf1';
}
.icon-liebherr-service-desk-icon-rgb-64px:before {
	content: '\eaf2';
}
.icon-liebherr-share-icon-rgb-64px:before {
	content: '\eaf3';
}
.icon-liebherr-shower-men-icon-rgb-64px:before {
	content: '\eaf4';
}
.icon-liebherr-shower-women-icon-rgb-64px:before {
	content: '\eaf5';
}
.icon-liebherr-signpost-icon-rgb-64px:before {
	content: '\eaf6';
}
.icon-liebherr-spare-parts-shipping-icon-rgb-64px:before {
	content: '\eaf7';
}
.icon-liebherr-target-icon-rgb-64px:before {
	content: '\eaf8';
}
.icon-liebherr-taxi-icon-rgb-64px:before {
	content: '\eaf9';
}
.icon-liebherr-toilets-icon-rgb-64px:before {
	content: '\eafa';
}
.icon-liebherr-train-icon-rgb-64px:before {
	content: '\eafb';
}
.icon-liebherr-underground-icon-rgb-64px:before {
	content: '\eafc';
}
.icon-liebherr-wardrobe-men-icon-rgb-64px:before {
	content: '\eafd';
}
.icon-liebherr-wardrobe-women-icon-rgb-64px:before {
	content: '\eafe';
}
.icon-liebherr-wheelchair-icon-rgb-64px:before {
	content: '\eaff';
}
.icon-liebherr-wifi-icon-rgb-64px:before {
	content: '\eb00';
}
.icon-liebherr-woman-icon-rgb-64px:before {
	content: '\eb01';
}
.icon-liebherr-wrench-icon-rgb-64px:before {
	content: '\eb02';
}
.icon-liebherr-app-android-icon-rgb-64px:before {
	content: '\eb03';
}
.icon-liebherr-arrow-up-down-icon-rgb-64px:before {
	content: '\eb04';
}
.icon-liebherr-bike-icon-rgb-64px:before {
	content: '\eb05';
}
.icon-liebherr-bus-icon-rgb-64px:before {
	content: '\eb06';
}
.icon-liebherr-cardhouse-icon-rgb-64px:before {
	content: '\eb07';
}
.icon-liebherr-car-icon-rgb-64px:before {
	content: '\eb08';
}
.icon-liebherr-cleaning-icon-rgb-64px:before {
	content: '\eb09';
}
.icon-liebherr-cup-icon-rgb-64px:before {
	content: '\eb0a';
}
.icon-liebherr-delivery-truck-icon-rgb-64px:before {
	content: '\eb0b';
}
.icon-liebherr-dashboard-icon-rgb-64px:before {
	content: '\eb0c';
}
.icon-liebherr-confirm-message-icon-rgb-64px:before {
	content: '\eb0d';
}
.icon-liebherr-envelope-open-icon-rgb-64px:before {
	content: '\eb0e';
}
.icon-liebherr-load-securing-icon-rgb-64px:before {
	content: '\eb0f';
}
.icon-liebherr-turn-off-engines-icon-rgb-64px:before {
	content: '\eb10';
}
.icon-liebherr-at-icon-rgb-64px:before {
	content: '\eb11';
}
.icon-liebherr-digital-services-MyMaintenance-icon-rgb-64px:before {
	content: '\eb12';
}
.icon-liebherr-no-wifi-icon-rgb-64px:before {
	content: '\eb13';
}
.icon-liebherr-compare-icon-rgb-64px:before {
	content: '\eb14';
}
.icon-liebherr-content-delivery-portal-icon-rgb-64px:before {
	content: '\eb15';
}
.icon-liebherr-confirmation-icon-rgb-64px:before {
	content: '\eb16';
}
.icon-liebherr-compare-invert-icon-rgb-64px:before {
	content: '\eb17';
}
.icon-liebherr-whatsapp-icon-rgb-64px:before {
	content: '\eb18';
}
.icon-liebherr-paragraph-icon-rgb-64px:before {
	content: '\eb19';
}
.icon-liebherr-permantently-suppressed-DPF-regeneration-icon-rgb-64px:before {
	content: '\eb1a';
}
.icon-liebherr-virtual-smartcard-icon-rgb-64px:before {
	content: '\eb1b';
}
.icon-liebherr-drops-icon-rgb-64px:before {
	content: '\eb1c';
}
.icon-liebherr-hourglass-icon-rgb-64px:before {
	content: '\eb1d';
}
.icon-liebherr-liduro-power-port-icon-rgb-64px:before {
	content: '\eb1e';
}
.icon-liebherr-no-grid-access-icon-rgb-64px:before {
	content: '\eb1f';
}
.icon-liebherr-hydraulic-oils-low-temperature-icon-rgb-64px:before {
	content: '\eb20';
}
.icon-liebherr-filter-icon-rgb-64px:before {
	content: '\eb21';
}
.icon-liebherr-digital-services-troubleshoot-advisor-icon-rgb-64px:before {
	content: '\eb22';
}
.icon-liebherr-dosing-icon-rgb-64px:before {
	content: '\eb23';
}
.icon-liebherr-employee-bicycles-icon-rgb-64px:before {
	content: '\eb24';
}
.icon-liebherr-employer-funded-pension-2-icon-rgb-64px:before {
	content: '\eb25';
}
.icon-liebherr-production-workers-icon-rgb-64px:before {
	content: '\eb26';
}
.icon-liebherr-professionals-executives-icon-rgb-64px:before {
	content: '\eb27';
}
.icon-liebherr-public-transport-job-tickets-icon-rgb-64px:before {
	content: '\eb28';
}
.icon-liebherr-brochures-icon-rgb-64px:before {
	content: '\eb29';
}
.icon-liebherr-digital-services-icon-rgb-64px:before {
	content: '\eb2a';
}
.icon-liebherr-alpha-head-black-icon-rgb-64px:before {
	content: '\eb2b';
}
.icon-liebherr-alpha-text-bold-icon-rgb-64px:before {
	content: '\eb2c';
}
.icon-liebherr-alpha-text-regular-icon-rgb-64px:before {
	content: '\eb2d';
}
.icon-liebherr-digital-services-MyAssets-icon-rgb-64px:before {
	content: '\eb2e';
}
.icon-liebherr-camera-icon-rgb-64px:before {
	content: '\eb2f';
}
.icon-liebherr-clock-icon-rgb-64px:before {
	content: '\eb30';
}
.icon-liebherr-push-icon-rgb-64px:before {
	content: '\eb31';
}
.icon-liebherr-shuttle-bus-icon-rgb-64px:before {
	content: '\eb32';
}
.icon-liebherr-smoking-prohibited-icon-rgb-64px:before {
	content: '\eb33';
}
.icon-liebherr-sound-off-icon-rgb-64px:before {
	content: '\eb34';
}
.icon-liebherr-stairs-icon-rgb-64px:before {
	content: '\eb35';
}
.icon-liebherr-technical-room-icon-rgb-64px:before {
	content: '\eb36';
}
.icon-liebherr-video-surveillance-icon-rgb-64px:before {
	content: '\eb37';
}
.icon-liebherr-wardrobe-icon-rgb-64px:before {
	content: '\eb38';
}
.icon-liebherr-with-hand-to-wipe-icon-rgb-64px:before {
	content: '\eb39';
}
.icon-liebherr-access-control-icon-rgb-64px:before {
	content: '\eb3a';
}
.icon-liebherr-BMZ-icon-rgb-64px:before {
	content: '\eb3b';
}
.icon-liebherr-bus-stop-icon-rgb-64px:before {
	content: '\eb3c';
}
.icon-liebherr-cafe-staff-only-icon-rgb-64px:before {
	content: '\eb3d';
}
.icon-liebherr-do-not-enter-icon-rgb-64px:before {
	content: '\eb3e';
}
.icon-liebherr-do-not-use-in-case-of-fire-icon-rgb-64px:before {
	content: '\eb3f';
}
.icon-liebherr-entire-gesture-control-icon-rgb-64px:before {
	content: '\eb40';
}
.icon-liebherr-entry-staff-only-icon-rgb-64px:before {
	content: '\eb41';
}
.icon-liebherr-escalator-icon-rgb-64px:before {
	content: '\eb42';
}
.icon-liebherr-exit-icon-rgb-64px:before {
	content: '\eb43';
}
.icon-liebherr-floor-icon-rgb-64px:before {
	content: '\eb44';
}
.icon-liebherr-lockers-icon-rgb-64px:before {
	content: '\eb45';
}
.icon-liebherr-meeting-point-icon-rgb-64px:before {
	content: '\eb46';
}
.icon-liebherr-meeting-room-icon-rgb-64px:before {
	content: '\eb47';
}
.icon-liebherr-office-icon-rgb-64px:before {
	content: '\eb48';
}
.icon-liebherr-orientation-system-icon-rgb-64px:before {
	content: '\eb49';
}
.icon-liebherr-pedestrian-walkway-icon-rgb-64px:before {
	content: '\eb4a';
}
.icon-liebherr-phoning-prohibited-icon-rgb-64px:before {
	content: '\eb4b';
}
.icon-liebherr-photography-prohibited-icon-rgb-64px:before {
	content: '\eb4c';
}
.icon-liebherr-company-icon-rgb-64px:before {
	content: '\eb4d';
}
.icon-liebherr-pull-icon-rgb-64px:before {
	content: '\eb4e';
}
.icon-liebherr-gearwheel-icon-rgb-64px:before {
	content: '\eb4f';
}
.icon-liebherr-globe-icon-rgb-64px:before {
	content: '\eb50';
}
.icon-liebherr-graduate-icon-rgb-64px:before {
	content: '\eb51';
}
.icon-liebherr-arrow-right-icon-rgb-64px:before {
	content: '\eb52';
}
.icon-liebherr-arrow-left-icon-rgb-64px:before {
	content: '\eb53';
}
.icon-liebherr-press-area-icon-rgb-64px:before {
	content: '\eb54';
}
.icon-liebherr-day-care-icon-rgb-64px:before {
	content: '\eb55';
}
.icon-liebherr-discounts-icon-rgb-64px:before {
	content: '\eb56';
}
.icon-liebherr-Goals-and-benefits-icon-rgb-64px:before {
	content: '\eb57';
}
.icon-liebherr-hr-administration-icon-rgb-64px:before {
	content: '\eb58';
}
.icon-liebherr-implementation-analysis-icon-rgb-64px:before {
	content: '\eb59';
}
.icon-liebherr-numbered-list-icon-rgb-64px:before {
	content: '\eb5a';
}
.icon-liebherr-innovation-pipeline-icon-rgb-64px:before {
	content: '\eb5b';
}
.icon-liebherr-key-figures-library-icon-rgb-64px:before {
	content: '\eb5c';
}
.icon-liebherr-labor-relations-icon-rgb-64px:before {
	content: '\eb5d';
}
.icon-liebherr-legal-icon-rgb-64px:before {
	content: '\eb5e';
}
.icon-liebherr-notebook-icon-rgb-64px:before {
	content: '\eb5f';
}
.icon-liebherr-offboarding-icon-rgb-64px:before {
	content: '\eb60';
}
.icon-liebherr-participation-icon-rgb-64px:before {
	content: '\eb61';
}
.icon-liebherr-pension-icon-rgb-64px:before {
	content: '\eb62';
}
.icon-liebherr-personal-devolpement-icon-rgb-64px:before {
	content: '\eb63';
}
.icon-liebherr-problems-icon-rgb-64px:before {
	content: '\eb64';
}
.icon-liebherr-questionaire-icon-rgb-64px:before {
	content: '\eb65';
}
.icon-liebherr-reasons-for-rejection-icon-rgb-64px:before {
	content: '\eb66';
}
.icon-liebherr-text-indent-icon-rgb-64px:before {
	content: '\eb67';
}
.icon-liebherr-solutions-icon-rgb-64px:before {
	content: '\eb68';
}
.icon-liebherr-submitter-behavior-icon-rgb-64px:before {
	content: '\eb69';
}
.icon-liebherr-survey-1-icon-rgb-64px:before {
	content: '\eb6a';
}
.icon-liebherr-system-usage-icon-rgb-64px:before {
	content: '\eb6b';
}
.icon-liebherr-talent-icon-rgb-64px:before {
	content: '\eb6c';
}
.icon-liebherr-tax-icon-rgb-64px:before {
	content: '\eb6d';
}
.icon-liebherr-unlink-icon-rgb-64px:before {
	content: '\eb6e';
}
.icon-liebherr-vote-icon-rgb-64px:before {
	content: '\eb6f';
}
.icon-liebherr-administration-key-figures-icon-rgb-64px:before {
	content: '\eb70';
}
.icon-liebherr-benefit-analysis-icon-rgb-64px:before {
	content: '\eb71';
}
.icon-liebherr-bonus-shop-icon-rgb-64px:before {
	content: '\eb72';
}
.icon-liebherr-bpm-basis-icon-rgb-64px:before {
	content: '\eb73';
}
.icon-liebherr-career-icon-rgb-64px:before {
	content: '\eb74';
}
.icon-liebherr-consolidate-icon-rgb-64px:before {
	content: '\eb75';
}
.icon-liebherr-CR-icon-rgb-64px:before {
	content: '\eb76';
}
.icon-liebherr-discussion-icon-rgb-64px:before {
	content: '\eb77';
}
.icon-liebherr-discussion-voting-icon-rgb-64px:before {
	content: '\eb78';
}
.icon-liebherr-double-gearwheel-checked-icon-rgb-64px:before {
	content: '\eb79';
}
.icon-liebherr-double-gearwheel-crossed-icon-rgb-64px:before {
	content: '\eb7a';
}
.icon-liebherr-ground-floor-icon-rgb-64px:before {
	content: '\eb7b';
}
.icon-liebherr-upper-floor-icon-rgb-64px:before {
	content: '\eb7c';
}
.icon-liebherr-tag-icon-rgb-64px:before {
	content: '\eb7d';
}
.icon-liebherr-sort-arrow-icon-rgb-64px:before {
	content: '\eb7e';
}
.icon-liebherr-globe-reduced-icon-rgb-64px:before {
	content: '\eb7f';
}
.icon-liebherr-kombi-greifer-icon-rgb-64px:before {
	content: '\eb80';
}
.icon-liebherr-herzform-greifer-icon-rgb-64px:before {
	content: '\eb81';
}
.icon-liebherr-stroke-installation-length-icon-rgb-64px:before {
	content: '\eb82';
}
.icon-liebherr-varnishing-icon-rgb-64px:before {
	content: '\eb83';
}
.icon-liebherr-diameter-icon-rgb-64px:before {
	content: '\eb84';
}
.icon-liebherr-hydz-configurator-icon-rgb-64px:before {
	content: '\eb85';
}
.icon-liebherr-city-icon-rgb-64px:before {
	content: '\eb86';
}
.icon-liebherr-360-icon-rgb-64px:before {
	content: '\eb87';
}
.icon-liebherr-hammer-icon-rgb-64px:before {
	content: '\eb88';
}
.icon-liebherr-fuel-extraction-icon-rgb-64px:before {
	content: '\eb89';
}
.icon-liebherr-exhaust-after-treatment-icon-rgb-64px:before {
	content: '\eb8a';
}
.icon-liebherr-electric-immobilizer-icon-rgb-64px:before {
	content: '\eb8b';
}
.icon-liebherr-automated-engine-shutdown-icon-rgb-64px:before {
	content: '\eb8c';
}
.icon-liebherr-2030-icon-rgb-64px:before {
	content: '\eb8d';
}
.icon-liebherr-weighing-system-icon-rgb-64px:before {
	content: '\eb8e';
}
.icon-liebherr-traceability-icon-rgb-64px:before {
	content: '\eb8f';
}
.icon-liebherr-petrol-pump-icon-rgb-64px:before {
	content: '\eb90';
}
.icon-liebherr-personalized-driver-profile-icon-rgb-64px:before {
	content: '\eb91';
}
.icon-liebherr-mill-icon-rgb-64px:before {
	content: '\eb92';
}
.icon-liebherr-bold-icon-rgb-64px:before {
	content: '\eb93';
}
.icon-liebherr-bulleted-list-icon-rgb-64px:before {
	content: '\eb94';
}
.icon-liebherr-divider-line-icon-rgb-64px:before {
	content: '\eb95';
}
.icon-liebherr-headline-icon-rgb-64px:before {
	content: '\eb96';
}
.icon-liebherr-italic-icon-rgb-64px:before {
	content: '\eb97';
}
.icon-liebherr-expertsmeeting-icon-rgb-64px:before {
	content: '\eb98';
}
.icon-liebherr-mentoring-icon-rgb-64px:before {
	content: '\eb99';
}
.icon-liebherr-representative-icon-rgb-64px:before {
	content: '\eb9a';
}
.icon-liebherr-reman-icon-rgb-64px:before {
	content: '\eb9b';
}
.icon-liebherr-myliebherr-icon-rgb-64px:before {
	content: '\eb9c';
}
.icon-liebherr-bluRox-icon-rgb-64px:before {
	content: '\eb9d';
}
.icon-liebherr-lidat-icon-rgb-64px:before {
	content: '\eb9e';
}
.icon-liebherr-myOrganization-icon-rgb-64px:before {
	content: '\eb9f';
}
.icon-liebherr-4C-power-icon-rgb-64px:before {
	content: '\eba0';
}
.icon-liebherr-mysuccess-icon-rgb-64px:before {
	content: '\eba1';
}
.icon-liebherr-crane-configurator-icon-rgb-64px:before {
	content: '\eba2';
}
.icon-liebherr-lisim-icon-rgb-64px:before {
	content: '\eba3';
}
.icon-liebherr-litab-icon-rgb-64px:before {
	content: '\eba4';
}
.icon-liebherr-partsXchanger-icon-rgb-64px:before {
	content: '\eba5';
}
.icon-liebherr-procom-icon-rgb-64px:before {
	content: '\eba6';
}
.icon-lieberr-lipos-icon-rgb-64px:before {
	content: '\eba7';
}
.icon-liebherr-LiGO-icon-rgb-64px:before {
	content: '\eba8';
}
.icon-liebherr-shared-services-icon-rgb-64px:before {
	content: '\eba9';
}
.icon-liebherr-liAS-icon-rgb-64px:before {
	content: '\ebaa';
}
.icon-liebherr-AER-unlock-icon-rgb-64px:before {
	content: '\ebab';
}
.icon-liebherr-family-and-work-2-icon-rgb-64px:before {
	content: '\ebac';
}
.icon-liebherr-link-icon-rgb-64px:before {
	content: '\ebad';
}
.icon-liebherr-status-message-inprogress-warning-icon-rgb-64px:before {
	content: '\ebae';
}
.icon-liebherr-status-message-verified-active-icon-rgb-64px:before {
	content: '\ebaf';
}
.icon-liebherr-status-message-canceled-error-icon-rgb-64px:before {
	content: '\ebb0';
}
.icon-liebherr-status-message-completed-successful-new-icon-rgb-64px:before {
	content: '\ebb1';
}
.icon-liebherr-status-message-created-icon-rgb-64px:before {
	content: '\ebb2';
}
.icon-liebherr-status-message-draft-inactive-icon-rgb-64px:before {
	content: '\ebb3';
}
.icon-liebherr-myliebherr-application-icon-rgb-64px:before {
	content: '\ebb4';
}
.icon-liebherr-paypal-2-icon-rgb-64px:before {
	content: '\ebb5';
}
.icon-liebherr-rfid-icon-rgb-64px:before {
	content: '\ebb6';
}
.icon-liebherr-xpert-assist-icon-rgb-64px:before {
	content: '\ebb7';
}
.icon-liebherr-gluten-icon-rgb-64px:before {
	content: '\ebb8';
}
.icon-liebherr-vegan-icon-rgb-64px:before {
	content: '\ebb9';
}
.icon-liebherr-gluten-free-icon-rgb-64px:before {
	content: '\ebba';
}
.icon-liebherr-concrete-technology-configurator-icon-rgb-64px:before {
	content: '\ebbb';
}
.icon-liebherr-digital-solutions-icon-rgb-64px:before {
	content: '\ebbc';
}
.icon-liebherr-key-icon-rgb-64px:before {
	content: '\ebbd';
}
.icon-liebherr-ePricelist-icon-rgb-64px:before {
	content: '\ebbe';
}
.icon-liebherr-towercrane-portal-icon-rgb-64px:before {
	content: '\ebbf';
}
.icon-liebherr-icon-statics-selector-64px:before {
	content: '\ebc0';
}
.icon-liebherr-schwerbehindertenvertretung-icon-rgb-64px:before {
	content: '\ebc1';
}
.icon-liebherr-font-arrow-up-icon-rgb-64px:before {
	content: '\ebc2';
}
.icon-liebherr-font-arrow-down-icon-rgb-64px:before {
	content: '\ebc3';
}
.icon-liebherr-specialized-trade-icon-rgb-64px:before {
	content: '\ebc4';
}
.icon-liebherr-kitchen-icon-rgb-64px:before {
	content: '\ebc5';
}
.icon-liebherr-laboratory-trade-icon-rgb:before {
	content: '\ebc6';
}
.icon-liebherr-monolith-icon-rgb-64px:before {
	content: '\ebc7';
}
.icon-liebherr-einschubmotor-icon-rgb-64px:before {
	content: '\ebc8';
}
.icon-liebherr-pumpe-geschlossener-kreis-icon-rgb-64px:before {
	content: '\ebc9';
}
.icon-liebherr-pumpe-offener-kreis-icon-rgb-64px:before {
	content: '\ebca';
}
.icon-liebherr-anbaumotor-variabel-icon-rgb-64px:before {
	content: '\ebcb';
}
.icon-liebherr-AxM-icon-rgb-64px:before {
	content: '\ebcc';
}
.icon-liebherr-server-icon-rgb-64px:before {
	content: '\ebcd';
}
.icon-liebherr-too-many-requests-icon-rgb-64px:before {
	content: '\ebce';
}
.icon-liebherr-no-data-icon-rgb-64px:before {
	content: '\ebcf';
}
.icon-liebherr-not-found-icon-rgb-64px:before {
	content: '\ebd0';
}
.icon-liebherr-server-error-icon-rgb-64px:before {
	content: '\ebd1';
}
.icon-liebherr-brezel-icon-rgb-64px:before {
	content: '\ebd2';
}
.icon-liebherr-time-to-market-icon-rgb-64px:before {
	content: '\ebd3';
}
.icon-liebherr-spuelmaschinen-geeignet-icon-rgb-64px:before {
	content: '\ebd4';
}
.icon-liebherr-nicht-lebensmittelecht-icon-rgb-64px:before {
	content: '\ebd5';
}
.icon-liebherr-nicht-spuelmaschinen-geeignet-icon-rgb-64px:before {
	content: '\ebd6';
}
.icon-liebherr-lebensmittelecht-icon-rgb-64px:before {
	content: '\ebd7';
}
.icon-liebherr-tower-crane-repository-icon-rgb-64px:before {
	content: '\ebd8';
}
.icon-liebherr-managing-director-icon-rgb-64px:before {
	content: '\ebd9';
}
.icon-liebherr-touch-display-icon-rgb-64px:before {
	content: '\ebda';
}
.icon-liebherr-tie-in-strut-calculator-rgb-64px:before {
	content: '\ebdb';
}
.icon-liebherr-mono-icon-rgb-64px:before {
	content: '\ebde';
}
.icon-liebherr-chest-freezer-icon-rgb-64px:before {
	content: '\ebdf';
}
.icon-liebherr-wine-plus-icon-rgb-64px:before {
	content: '\ebe0';
}
.icon-liebherr-smamo-icon-rgb-64px:before {
	content: '\ebe1';
}
.icon-liebherr-freezer-bottom-icon-rgb-64px:before {
	content: '\ebe2';
}
.icon-liebherr-freezer-icon-rgb-64px:before {
	content: '\ebe3';
}
.icon-liebherr-frenchdoor-icon-rgb-64px:before {
	content: '\ebe4';
}
.icon-liebherr-HAU-integrated-icon-rgb-64px:before {
	content: '\ebe5';
}
.icon-liebherr-HAU-integrated-plus-icon-rgb-64px:before {
	content: '\ebe6';
}
.icon-liebherr-SBS-icon-rgb-64px:before {
	content: '\ebe7';
}
.icon-liebherr-top-freezer-icon-rgb-64px:before {
	content: '\ebe8';
}
.icon-liebherr-wine-icon-rgb-64px:before {
	content: '\ebe9';
}
.icon-liebherr-freestanding-icon-rgb-64px:before {
	content: '\ebea';
}
.icon-liebherr-freestanding-plus-icon-rgb-64px:before {
	content: '\ebeb';
}
.icon-liebherr-my-style-icon-rgb-64px:before {
	content: '\ebec';
}
.icon-liebherr-CTPU-icon-rgb-64px:before {
	content: '\e936';
}
.icon-liebherr-BT-icon-rgb-64px:before {
	content: '\e938';
}
.icon-liebherr-MACR-icon-rgb-64px:before {
	content: '\e93f';
}
.icon-liebherr-LWE-icon-rgb-64px:before {
	content: '\e941';
}
.icon-liebherr-EMT-icon-rgb-64px:before {
	content: '\e942';
}
.icon-liebherr-MCC-icon-rgb-64px:before {
	content: '\e949';
}
.icon-liebherr-TC-icon-rgb-64px:before {
	content: '\e953';
}
.icon-liebherr-MIN-icon-rgb-64px:before {
	content: '\e95f';
}
.icon-liebherr-MK-icon-rgb-64px:before {
	content: '\e963';
}
.icon-liebherr-LWE-icon-rgb-64px:before {
	content: '\e964';
}
.icon-liebherr-YLWE-icon-rgb-64px:before {
	content: '\e964';
}
.icon-liebherr-LHSHOP-icon-rgb-64px:before {
	content: '\e96c';
}
.icon-liebherr-LHSHOPRETAILER-icon-rgb-64px:before {
	content: '\e96c';
}
.icon-liebherr-PE-icon-rgb-64px:before {
	content: '\e96e';
}
.icon-liebherr-HOME-icon-rgb-64px:before {
	content: '\e97d';
}
.icon-liebherr-AER-icon-rgb-64px:before {
	content: '\e983';
}
.icon-liebherr-COTC-icon-rgb-64px:before {
	content: '\e9a1';
}
.icon-liebherr-LVT-icon-rgb-64px:before {
	content: '\e9a2';
}
